import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6bc48eb9&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=6bc48eb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc48eb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc48eb9')) {
      api.createRecord('6bc48eb9', component.options)
    } else {
      api.reload('6bc48eb9', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=6bc48eb9&scoped=true&", function () {
      api.rerender('6bc48eb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/PreChatForm/Settings.vue"
export default component.exports